import React, { useState, useEffect, useRef } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { SuperInfoPause } from "../actions/websocket";
import { showmodalPause } from "../actions";
const { connection_platform } = require("../services/api");

const TimeCounterInternal = ({ horario, status, max, iduser, showmodalpause }) => {
  const [time, setTime] = useState(!isNaN(horario) ? horario * 1000 : 0); // Estado para o tempo
  const intervalRef = useRef(null); // Referência para armazenar o identificador do intervalo

  useEffect(() => {
    // Inicia o contador quando o componente é montado
    const startTime = Date.now() - time;

    intervalRef.current = setInterval(() => {
      setTime(Date.now() - startTime); // Atualiza o tempo decorrido
    }, connection_platform.milliseconds || 1000); // Atualiza a cada segundo

    return () => {
      // Limpa o intervalo ao desmontar
      clearInterval(intervalRef.current);
    };
  }, []); // Executa apenas uma vez ao montar

  useEffect(() => {
    // Verifica se o tempo máximo foi atingido
    if (
      max > 0 &&
      status === "Pausado" &&
      Math.round(Moment.duration(time).asSeconds()) === max
    ) {
      showmodalpause(true); // Mostra o modal
      SuperInfoPause(iduser); // Chama a ação de pausa
    }
  }, [time, max, status, iduser, showmodalpause]); // Reexecuta sempre que o tempo, max, status ou iduser mudar

  // Formata o tempo para exibição
  const formattedTime = Moment.utc(time).format("HH:mm:ss");

  return <React.Fragment>{formattedTime}</React.Fragment>;
};

// Conexão com Redux
const mapDispatchToProps = (dispatch) => ({
  showmodalpause: (params) => dispatch(showmodalPause(params)),
});

export default connect(null, mapDispatchToProps)(TimeCounterInternal);
